import { render, staticRenderFns } from "./SelectSeller.vue?vue&type=template&id=445443d5&lang=html"
import script from "./SelectSeller.vue?vue&type=script&lang=js"
export * from "./SelectSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports